import { render, staticRenderFns } from "./Multimedias.vue?vue&type=template&id=81afbc50&scoped=true&"
import script from "./Multimedias.vue?vue&type=script&lang=js&"
export * from "./Multimedias.vue?vue&type=script&lang=js&"
import style0 from "./Multimedias.vue?vue&type=style&index=0&id=81afbc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81afbc50",
  null
  
)

export default component.exports